import { useEffect, useState, useContext } from "react";
import axios from "axios";
import EditGame from "./EditGame";
import { AppContext } from "../../context/AppContext";
import "../Backend/assets/css/gamelist.css";

//const baseUrl =  "https://htmlgames4u.com/api";
const GameWrapper = () => {
  const [status, setStatus] = useState("");
  const [folders, setFolders] = useState(null);
  const [getCategory, setGetCategory] = useState([]);
  const [gameList, setGameList] = useState([]);
  const [thumbnail, setThumbnail] = useState(null);
  const [preview, setPreview] = useState(null);
  const [gameNameData, setGameNameData] = useState([]);
  const [gameurl, setGameUrl] = useState("");
  const [thumbnailPath, setThumbnailPath] = useState("");
  const [uploadImgMsg, setUploadImgMsg] = useState("");
  const [editingGameId, setEditingGameId] = useState(null);
  const [savegameEnabled, setSavegameEnabled] = useState(false);
  const [metatag, setMetaTag] = useState();
  const [openAddGame, setAddGame] = useState(false);

  const { baseUrl, token } = useContext(AppContext);
  const fetchData = async () => {
    try {
      const res = await axios.get(`${baseUrl}/get-category`);
      if (res.data.success) {
        setGetCategory(res.data.data);
      } else {
        console.error("Failed to fetch categories:", res.data.message);
      }
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
    try {
      const res = await axios.get(`${baseUrl}/get-game-list`);
      if (res.data.message) {
        setGameList(res.data.getAllGame);
      } else {
        console.error("Failed to fetch game list:", res.data.message);
      }
    } catch (err) {
      console.error("Error fetching game list:", err);
    }
  };
  useEffect(() => {
    fetchData();
    axios.get(`${baseUrl}/hello`).then((res) => {
      if (Array.isArray(res.data.message)) {
        setGameNameData(res.data.message);
      } else {
        console.error("Expected array, got:", res.data.message);
      }
    });
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    const thmbnaiimg_path = `/thumbnail/${file.name}`;
    setThumbnailPath(thmbnaiimg_path);
    setThumbnail(file);
    setPreview(URL.createObjectURL(file)); // show preview
  };

  const handleThumbUpload = async (e) => {
    if (!thumbnail) {
      alert("Please select a file first!");
      return;
    }
    e.preventDefault();
    const formData = new FormData();
    formData.append("thumbnail", thumbnail);

    try {
      const res = await axios.post(`${baseUrl}/upload-thumbnail`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res) {
        setSavegameEnabled(true);
        setUploadImgMsg("Thumbnail Img upload successfully");
      }
    } catch (err) {
      console.error(err);
    }
  };
  const handleUpload = async (event) => {
    event.preventDefault();

    const files = Array.from(event.target.files);
    const formData = new FormData();
    let mainFolder = "";

    for (const file of files) {
      formData.append("files", file, file.webkitRelativePath);
      if (!mainFolder) {
        const pathParts = file.webkitRelativePath.split("/");
        if (pathParts.length > 1) {
          mainFolder = pathParts[0];
        }
      }
    }

    try {
      const res = await axios.post(`${baseUrl}/upload-folder`, formData);
      if (res.data.message) {
        setFolders(mainFolder);
      }
    } catch (err) {
      console.error("Upload error:", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    const formData = {
      gameName: form.gameName.value,
      category: form.category.value,
      enabled: form.enabled.checked,
      advertised: form.advertised.checked,
      advertised_name: form.add_name.value,
      folder_path: `/gameFolder/${form.game_title.value}`,
      game_title: form.game_title.value,
      url: gameurl,
      thumbnail_img_path: thumbnailPath,
      description: form.description.value,
      metatag: form.metatag.value,
      meta_title: form.meta_title.value,
      meta_keyword: form.meta_keyword.value,
      meta_description: form.meta_description.value,
      gameType: form.gameType ? form.gameType.value : "",
      iso_link: form.iso_link ? form.iso_link.value : "",
      playstore_link: form.playstore_link ? form.playstore_link.value : "",
    };

    try {
      const res = await axios.post(`${baseUrl}/save-game`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.data.message) {
        setStatus(res.data.message);
        setGameList([...gameList, res.data.gamelist]);

        setUploadImgMsg("");
        setTimeout(() => {
          setStatus("");
        }, 3000);
      } else {
        setStatus("Game saved successfully!");
      }
    } catch (err) {
      console.error("Save error:", err);
      setStatus("Error saving game");
    }
  };
  const handleDelete = async (id) => {
    const gameId = id; // Assuming each game has a unique ID
    try {
      const res = await axios.post(
        `${baseUrl}/delete-game`,
        { id: gameId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.data.message) {
        setGameList(gameList.filter((_, i) => i !== index));
      } else {
        console.error("Error deleting game:", res.data.message);
      }
    } catch (err) {
      console.error("Delete error:", err);
    }
  };
  const handleGameTitleChange = (event) => {
    const url = event.target.value;
    const URL = url.replace(/-/g, "").toLowerCase();
    setGameUrl(URL);
  };

  return (
    <div className="container">
      {/* Form for adding a new game */}
      <div className="games_main">
        <h1 className="heading">Game</h1>
        <button
          onClick={() => {
            setAddGame((prev) => !prev);
          }}
        >
          Add New Game
        </button>
      </div>
      {openAddGame && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div className="main_model">
            <form onSubmit={handleSubmit}>
              <div className="form_field">
                <label>Game Name</label>
                <input
                  type="text"
                  name="gameName"
                  required
                  className="form-control"
                />
              </div>
              <div className="form_field">
                <label>Game Title</label>
                <select
                  onChange={handleGameTitleChange}
                  name="game_title"
                  required
                  className="form-control"
                >
                  <option value="">Select game_title</option>
                  {gameNameData.map((game_title, index) => (
                    <option key={index} value={game_title}>
                      {game_title}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form_field">
                <label>Game url</label>
                <input
                  type="text"
                  name="game_url"
                  value={gameurl}
                  required
                  className="form-control"
                />
              </div>
              <div className="form_field">
                <label>Category</label>
                <select name="category" required className="form-control">
                  <option value="">Select Category</option>
                  {getCategory.map((category, index) => (
                    <option key={index} value={category.name}>
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form_field">
                <label>Advertisement Name</label>
                <input
                  type="text"
                  name="add_name"
                  required
                  className="form-control"
                />
              </div>

              <div className="form_checkbox">
                <div>
                  <label>
                    <input type="checkbox" name="enabled" defaultChecked />{" "}
                    Enabled
                  </label>
                </div>

                <div>
                  <label>
                    <input type="checkbox" name="advertised" /> Advertised
                  </label>
                </div>
              </div>

              <div
                className="form_description"
                // style={{
                //   display: "flex",
                //   flexDirection: "column",
                //   padding: "4px",
                //   gap: "10px",
                //   maxWidth: "300px",
                //   border: "2px solid black",
                // }}
              >
                <label>
                  Description
                  <textarea
                    name="description"
                    rows="4"
                    cols="25"
                    placeholder="Enter your text here..."
                  ></textarea>
                </label>

                <label>
                  Upload Thumbnail
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                  />
                </label>
                <div>
                  <label style={{ marginBottom: "3px" }}>
                    Thumbnail path:{" "}
                    <span style={{ color: "red" }}>/var/www/html/</span>{" "}
                  </label>
                  <input
                    type="text"
                    name="thumbnail_path"
                    value={thumbnailPath}
                  />
                </div>
                {preview && (
                  <img
                    src={preview}
                    alt="Thumbnail Preview"
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                    }}
                  />
                )}

                <button onClick={handleThumbUpload}>Upload</button>
                <p style={{ color: "green" }}>{uploadImgMsg}</p>
              </div>
              <div style={{ display: "none" }} className="form_field">
                <label>Meta Tag:</label>
                <textarea
                  name="metatag"
                  rows="3"
                  cols="40"
                  placeholder="Enter SEO meta tags..."
                  className="form-control"
                />
              </div>
              <div className="form_field">
                <label>Meta Title:</label>
                <input type="text" name="meta_title" className="form-control" />
              </div>
              <div className="form_field">
                <label>Meta Keywords:</label>
                <input
                  type="text"
                  name="meta_keyword"
                  className="form-control"
                />
              </div>
              <div className="form_field">
                <label>Meta Description:</label>
                <textarea
                  name="meta_description"
                  rows="3"
                  cols="40"
                  placeholder="Enter SEO meta tags..."
                  className="form-control"
                />
              </div>

              <div className="form_field">
                <label>Game Type</label>
                <input
                  type="text"
                  name="gameType"
                  className="form-control"
                  placeholder="e.g. HTML5, Unity, etc."
                />
              </div>
              <div className="form_field">
                <label>ISO Link</label>
                <input
                  type="text"
                  name="iso_link"
                  className="form-control"
                  placeholder="Enter ISO download link"
                />
              </div>
              <div className="form_field">
                <label>Playstore Link</label>
                <input
                  type="text"
                  name="playstore_link"
                  className="form-control"
                  placeholder="Enter Playstore link"
                />
              </div>
              {/* <div>
          <label>Upload Game Folder:</label>
          <input
            type="file"
            webkitdirectory="true"
            directory="true"
            multiple
            onChange={handleUpload}
          />
          <div style={{ color: 'red' }}>{folders && 'Folder uploaded successfully'}</div>
        </div> */}

              <div className="form_btn">
                <button
                  disabled={!savegameEnabled}
                  type="submit"
                  // className="btn btn-primary"
                  className={!savegameEnabled ? "disabled" : "btn btn-primary"}
                >
                  Save Game
                </button>
                <div style={{ color: "green", marginTop: "10px" }}>
                  {status}
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
      {/* end */}
      {/* game list */}
      <div
        className="game_list"
        // style={{
        //   margin: "4px",
        //   marginTop: "10px",
        //   width: "90%",
        //   boxShadow: "2px 4px 8px rgba(0, 0, 0, 0.8)",
        //   padding: "20px",
        // }}
      >
        <h2 className="heading">Game List</h2>
        <div className="table_main">
          <table
            className="table table-bordered"
            // style={{
            //   width: "100%",
            //   textAlign: "center",
            //   borderCollapse: "collapse",
            // }}
          >
            <thead>
              <tr
                style={{ backgroundColor: "#f2f2f2", border: "1px solid #ddd" }}
              >
                <th>ID</th>
                <th>Game Name</th>
                <th>Title </th>
                <th>Category</th>
                <th>Enabled</th>
                <th>Advertised</th>
                <th>URL</th>
                <th>Folder Path</th>
                <th>Thubnail Path</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {gameList &&
                gameList.map((game, index) => (
                  <tr
                    key={index}
                    style={{
                      padding: "2px",
                      // backgroundColor: "#f2f2f2",
                      border: "1px solid #ddd",
                      textAlign: "center",
                    }}
                  >
                    <td>{index + 1}</td>
                    <td>{game.name}</td>
                    <td>{game.game_title}</td>
                    <td>{game.category}</td>
                    <td>{game.enable ? "Yes" : "No"}</td>
                    <td>{game.advertised ? "Yes" : "No"}</td>
                    <td>{game.url}</td>
                    <td>{game.folder_path}</td>
                    <td>{game.thumbnail_img_path}</td>
                    <td>
                      <button
                        className="edit"
                        onClick={() => setEditingGameId(game.id)}
                      >
                        Edit
                      </button>
                      <button
                        className="delete"
                        onClick={() => handleDelete(game.id)}
                      >
                        Delete
                      </button>
                    </td>
                    {/* <td>Add action buttons here if needed</td> */}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* end game list */}
      {/* Modal Overlay */}
      {editingGameId && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <EditGame
            gameId={editingGameId}
            onClose={() => setEditingGameId(null)}
            onUpdated={fetchData}
          />
        </div>
      )}
    </div>
  );
};

export default GameWrapper;
